import DOMPurify from "dompurify";

/**
 * Sanitizes HTML content using DOMPurify to prevent XSS attacks
 * Uses DOMPurify default config which strips scripts and dangerous handlers
 * while preserving safe template HTML (div, a, img, span, etc.)
 * @param {string} html - The HTML string to sanitize
 * @param {Object} options - DOMPurify configuration options to override defaults
 * @returns {string} - Sanitized HTML string
 */
export function sanitizeHtml(html, options = {}) {
    if (!html) {
        return "";
    }
    return DOMPurify.sanitize(html, options);
}
